import React from 'react'

export default function Footer() {
  return (
    <div className='container-fluid' id='footer'>
        <p>This App is made by @WEBbuilders (RAHUL BAGHEL): All Rights Reserved</p>
    </div>
  )
}
